// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__select___uVXCR {
}

.styles__trust_name___TP54q {
  margin-bottom: 0;
}

.styles__contentContainer___oeMe4 {
  display: flex;
  flex-direction: column;
}

@media print {

.styles__contentContainer___oeMe4 {
    display: block;
    margin: 0;
    padding: 0;
}
  }

.styles__form___bKeAN {
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
}

.styles__formItem___jkaxe {
}

.styles__halfWidth___w3uMZ {
  margin: 0 auto;
  width: 25%;
}

.styles__header___lEQtl {
  background: white;
  border-radius: 3px;
  margin: 0 0 20px;
  padding: 20px;
  width: 100%;
}

@media print {

.styles__header___lEQtl {
    position: fixed;
    top: 0;
}
  }

.styles__label___WpGXD {
}

.styles__localHeader___eqLjn {
}

.styles__localHeaderInner___YAk3C {
}

.styles__section___FGUzW {
}

@media print {

.styles__section___FGUzW {
    padding: 0;
}
  }

.styles__warning___aUuZT {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]};
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  font-size: 90%;
}

.styles__table___xfZpF {
  width: 100%;
}

.styles__table___xfZpF td,
  .styles__table___xfZpF th {
    font-weight: normal;
    padding-right: 20px;
  }

.styles__table___xfZpF > tbody tr:last-child td {
      border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    }

.styles__table___xfZpF > tbody tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

.styles__table___xfZpF > tbody tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

@media print {

.styles__table___xfZpF {
    page-break-after: always;
}
  }

.styles__reportInfo___HPWTR {
  float: left;
  text-align: left;
}

.styles__contactInfo___IfbjI {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  float: right;
  font-size: 0.75em;
  text-align: left;
}

.styles__logo___VfYTk {
  height: 35px;
}

.styles__reportHeader___dzJCp {
  display: block;
}

.styles__spacer___Pi1lj {
  height: 20px;
}

.styles__descriptionHeader___JQHvL {
  background-color: white;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
  margin-bottom: 50px;
  text-align: left;
}

.styles__nameHeader___egMA6 {
  border-top-left-radius: 3px;
  padding-left: 20px;
}

.styles__closeDateHeader___HtBVO {
  border-top-right-radius: 3px;
}

.styles__closeDateHeader___HtBVO,
.styles__nameHeader___egMA6,
.styles__tableHeader___qukAr {
  padding-bottom: 10px;
  padding-top: 10px;
}

.styles__label___WpGXD {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 10px;
}

.styles__dateCell___sO1gp,
.styles__ssnCell___X4VON {
  font-family: MaisonMono, monospace;
}

.styles__nameCell___MSorh {
  padding-left: 20px;
}

.styles__accountCell___ipHfn,
.styles__dateCell___sO1gp,
.styles__nameCell___MSorh,
.styles__ssnCell___X4VON {
  background-color: white;
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  padding-bottom: 10px;
  padding-top: 10px;
}

.styles__table___xfZpF a {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/DCFReport/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EACb,sBAAsB;AAMxB;;AALE;;AAJF;IAKI,cAAc;IACd,SAAS;IACT,UAAU;AAEd;EADE;;AAGF;EACE,aAA2B;EAA3B,wBAA2B;EAC3B,WAAW;AACb;;AAEA;AAEA;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;AAMb;;AAJE;;AAPF;IAQI,eAAe;IACf,MAAM;AAEV;EADE;;AAGF;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAMA;;AAHE;;AAHF;IAII,UAAU;AAEd;EADE;;AAGF;EACE,8DAA+B;EAC/B,8DAA0B;EAC1B,mDAAmB;EAEnB,cAAc;AAChB;;AAEA;EACE,WAAW;AAyBb;;AAvBE;;IAEE,mBAAmB;IACnB,mBAAmB;EACrB;;AAGE;MACE,qEAAoC;IACtC;;AAEA;MACE,8BAA8B;IAChC;;AAEA;MACE,+BAA+B;IACjC;;AAGF;;AAvBF;IAwBI,wBAAwB;AAE5B;EADE;;AAGF;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mDAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mDAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,uBAAuB;EACvB,kEAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtBlue, gtBlueLight, gtYellow, gtYellowDark, gtYellowLight, textLight from colors;\n\n.select {\n  composes: select from helpers;\n}\n\n.trust_name {\n  margin-bottom: 0;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: flex;\n  flex-direction: column;\n  @media print {\n    display: block;\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.form {\n  lost-flex-container: column;\n  width: 100%;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.halfWidth {\n  margin: 0 auto;\n  width: 25%;\n}\n\n.header {\n  background: white;\n  border-radius: 3px;\n  margin: 0 0 20px;\n  padding: 20px;\n  width: 100%;\n\n  @media print {\n    position: fixed;\n    top: 0;\n  }\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.localHeader {\n  composes: localHeader from helpers;\n}\n\n.localHeaderInner {\n  composes: localHeaderInner from helpers;\n}\n\n.section {\n  composes: section from helpers;\n\n  @media print {\n    padding: 0;\n  }\n}\n\n.warning {\n  background-color: gtYellowLight;\n  border: 1px solid gtYellow;\n  color: gtYellowDark;\n  composes: section from helpers;\n  font-size: 90%;\n}\n\n.table {\n  width: 100%;\n\n  td,\n  th {\n    font-weight: normal;\n    padding-right: 20px;\n  }\n\n  & > tbody tr:last-child {\n    td {\n      border-bottom: 1px solid gtBlueLight;\n    }\n\n    td:first-child {\n      border-bottom-left-radius: 3px;\n    }\n\n    td:last-child {\n      border-bottom-right-radius: 3px;\n    }\n  }\n\n  @media print {\n    page-break-after: always;\n  }\n}\n\n.reportInfo {\n  float: left;\n  text-align: left;\n}\n\n.contactInfo {\n  color: gtBlue;\n  float: right;\n  font-size: 0.75em;\n  text-align: left;\n}\n\n.logo {\n  height: 35px;\n}\n\n.reportHeader {\n  display: block;\n}\n\n.spacer {\n  height: 20px;\n}\n\n.descriptionHeader {\n  background-color: white;\n  color: textLight;\n  font-size: 12px;\n  margin-bottom: 50px;\n  text-align: left;\n}\n\n.nameHeader {\n  border-top-left-radius: 3px;\n  padding-left: 20px;\n}\n\n.closeDateHeader {\n  border-top-right-radius: 3px;\n}\n\n.closeDateHeader,\n.nameHeader,\n.tableHeader {\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.label {\n  color: textLight;\n  font-size: 10px;\n}\n\n.dateCell,\n.ssnCell {\n  font-family: MaisonMono, monospace;\n}\n\n.nameCell {\n  padding-left: 20px;\n}\n\n.accountCell,\n.dateCell,\n.nameCell,\n.ssnCell {\n  background-color: white;\n  border-top: 1px solid gtBlueLight;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.table a {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"select": `styles__select___uVXCR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"trust_name": `styles__trust_name___TP54q`,
	"contentContainer": `styles__contentContainer___oeMe4 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"form": `styles__form___bKeAN`,
	"formItem": `styles__formItem___jkaxe ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"halfWidth": `styles__halfWidth___w3uMZ`,
	"header": `styles__header___lEQtl`,
	"label": `styles__label___WpGXD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"localHeader": `styles__localHeader___eqLjn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeader"]}`,
	"localHeaderInner": `styles__localHeaderInner___YAk3C ${___CSS_LOADER_ICSS_IMPORT_1___.locals["localHeaderInner"]}`,
	"section": `styles__section___FGUzW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"warning": `styles__warning___aUuZT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"table": `styles__table___xfZpF`,
	"reportInfo": `styles__reportInfo___HPWTR`,
	"contactInfo": `styles__contactInfo___IfbjI`,
	"logo": `styles__logo___VfYTk`,
	"reportHeader": `styles__reportHeader___dzJCp`,
	"spacer": `styles__spacer___Pi1lj`,
	"descriptionHeader": `styles__descriptionHeader___JQHvL`,
	"nameHeader": `styles__nameHeader___egMA6`,
	"closeDateHeader": `styles__closeDateHeader___HtBVO`,
	"tableHeader": `styles__tableHeader___qukAr`,
	"dateCell": `styles__dateCell___sO1gp`,
	"ssnCell": `styles__ssnCell___X4VON`,
	"nameCell": `styles__nameCell___MSorh`,
	"accountCell": `styles__accountCell___ipHfn`
};
export default ___CSS_LOADER_EXPORT___;
